import { render, staticRenderFns } from "./SaleVatRegimeMultiSelect.vue?vue&type=template&id=ee38863a&scoped=true"
import script from "./SaleVatRegimeMultiSelect.vue?vue&type=script&lang=ts"
export * from "./SaleVatRegimeMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee38863a",
  null
  
)

export default component.exports